"use strict";function navigateToMiniProgram$(a){return ddSdk_1.ddSdk.invokeAPI(apiName,a)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.navigateToMiniProgram$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.navigation.navigateToMiniProgram";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.31"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.31"},_a)),exports.navigateToMiniProgram$=navigateToMiniProgram$,exports.default=navigateToMiniProgram$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/api/biz/navigation/navigateToMiniProgram.js
// module id = 1127
// module chunks = 106